import common from "../common";

export default class ParticleEmitter extends PIXI.Container{
    constructor(particleData, particleImages, autoRandomise = false) {
        super();
        this._autoRandomise = autoRandomise;
        this._particles = particleData;
        this._particleImages = particleImages;
        this._config = P3.assets.json(this._particles);
        this._emitter = null;
        this._looping = false;
        this.changeParticle();
        this.visible = false;
    }

    update() {
        if(this._emitter){
            this._emitter.update(P3.Ticker.dt);
        }
    }

    destroy(){
        if(this._emitter != null){
            this._emitter.destroy();
            this._emitter = null;
        }
        this.visible = false;

        super.destroy();
    }

    turnOff(){
        this._emitter.emit = false;
    }

    play(){
        if(this._emitter == null)
            this.changeParticle();

        this.visible = true;

        if(this._looping)
            this._emitter.emitterLifetime = -1;

        this._emitter.emit = true;
    }

    changeParticle(){
        if(!this._config)
            this._config = P3.assets.json(this._particles);
        this._emitter = new PIXI.particles.Emitter(this, this._particleImages, this._config);
    }

    enableLoop(){
        this._looping = true;
    }

    overrideDefaultConfig(newConfig){
        this._config = newConfig;
        this.changeParticle();
    }
}
ParticleEmitter.FLOUR_CLOUD = ["flour_cloud.png"];
ParticleEmitter.STEAM_CLOUD = ["steam_cloud.png"];
ParticleEmitter.SPARKLE = ["sparkle_00.png", "sparkle_01.png", "sparkle_02.png", "sparkle_03.png"];
ParticleEmitter.HEARTS = ["particle_heart.png"];

ParticleEmitter.RAISIN_IMAGE = ["particle_ing_raisin.png"];
ParticleEmitter.STRAWBERRY_IMAGE = ["particle_ing_strawberry_001.png","particle_ing_strawberry_002.png"];
ParticleEmitter.FLOUR_IMAGE = ["particle_ing_flour_002.png","particle_ing_flour_003.png","particle_ing_flour_004.png"];
ParticleEmitter.SUGAR_IMAGE = ["particle_ing_sugar_001.png","particle_ing_sugar_002.png"];

ParticleEmitter.BOWL_FLOUR_BURST_00 = "particle_bowl_flour_burst_00";
ParticleEmitter.BOWL_FLOUR_MIXING_00 = "particle_bowl_flour_mixing_00";
ParticleEmitter.BOWL_FLAVOURS_BURST_00 = "particle_bowl_flavours_burst_00";
ParticleEmitter.OVER_STEAM_LOOP_00 = "particle_over_steam_loop_00";
ParticleEmitter.ROLING_PIN_00 = "particle_rolling_pin_00";
ParticleEmitter.TOP_FLOUR_BURST_00 = "particle_top_flour_burst_00";
ParticleEmitter.FINAL_COOKIE_LOOP_00 = "particle_final_cookie_loop_00";
ParticleEmitter.OVEN_TRAY_COMPLETE = "particle_oven_tray_complete_00";
ParticleEmitter.LOVE_HEARTS = "particle_love_hearts_00";

//stage 2
ParticleEmitter.ING_EGG = "particle_ing_egg";
ParticleEmitter.ING_BUTTER = "particle_ing_butter";
ParticleEmitter.ING_CHOC_DARK = "particle_ing_choc_dark";
ParticleEmitter.ING_LEMON = "particle_ing_choc_lemon";
ParticleEmitter.ING_ORANGE = "particle_ing_choc_orange";
ParticleEmitter.ING_CHOC_WHITE = "particle_ing_choc_white";
//stage 1
ParticleEmitter.ING_FLOUR = "particle_ing_flour";
ParticleEmitter.ING_RAISIN = "particle_ing_rasin";
ParticleEmitter.ING_STRAWBERRY = "particle_ing_strawberry";
ParticleEmitter.ING_SUGAR = "particle_ing_sugar";
